module.exports = __webpack_public_path__ + "img/no_task1088.3f7f7538.png";